export default __webpack_public_path__ + "static/media/Autokriti_FirstDIV.7e8bee4b.webp";